import { observable, action } from 'mobx';

class NavStore {

  @observable navigation = '';
  
  @action changeNavigation(nav) {
    this.navigation = nav;
  }

}

export default new NavStore();



// WEBPACK FOOTER //
// ./src/stores/navigationStore.js